import Vue from 'vue'
import App from './App.vue'
import '@babel/polyfill'
import router from './router'
import './styles/common.scss'
import './js/initUI'
import './filters'
import httpInstance from './service'
import mixins from './mixins'
Vue.mixin(mixins)
import VueClipboard from './plugins/vue-clipboard'
Vue.use(VueClipboard)

Vue.prototype.$http = httpInstance
Vue.prototype.$store = {}
Vue.prototype.$bus = new Vue()
Vue.config.productionTip = false

import {initTheme, widgetTheme} from '@widget/ui'
Vue.prototype.$widgetTheme = widgetTheme;

if (
  window.PPDWebUI &&
  window.PPDWebUI.os.inApp &&
  window.PPDWebUI.os.channel === 'PPDLoanApp'
){
  const [
    version,
    firstVer,
    secondVer,
    thirdVer
  ] = PPDWebUI.os.buildVersion.match(/(\d+)\.(\d+)\.(\d+)/);

  if (parseInt(firstVer + secondVer.padStart(2, '0') + thirdVer.padStart(2, '0')) >= 90200) {
    initTheme({
      exclude: '[href*=loanappsvip]'
    });
  }
}

new Vue({
  router,
  render: h => h(App),
  created() {}
}).$mount('#app')
